module.exports = __webpack_public_path__ + "static/media/Language-down-arrow.0003f90f.svg";